import { Panel } from 'component/Space/Panel'
import { observer } from 'mobx-react-lite'
import { UnitButton } from 'page/ProfileScreen/Units/UnitButton'

export const Units = observer(() => {
  return <Panel>
    <UnitButton unit="cm" />
    <UnitButton unit="in" />
  </Panel>
})
